import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Muestreador } from './entity-muestreador.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityMuestreadorAdapter: EntityAdapter<Muestreador> =
  createEntityAdapter<Muestreador>({
    selectId: (model) => model.id,
    sortComparer: (a: Muestreador, b: Muestreador): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityMuestreadorState extends EntityState<Muestreador> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityMuestreadorState =
  entityMuestreadorAdapter.getInitialState({
    isLoading: false,
    error: null
  });
